/**
 * type: this is the "target" of the target
 * workbench: this is the URL to the workbench
 * create: this is the URL for creating this type of target
 * activate: this is the URLD for activating this target
 * confirmActivate: this is the confirmation activation URL
 * duplicate: this is the duplicate screen URL
 * edit: this is the edit screen URL
 */

// TODO make sure that all these constants are used only once
export const TARGET_CONSTANTS = {
  las: {
    name: 'LAS',
    type: 'linear_ad_sales',
    workbench: 'las-workbench',
    create: 'create-las',
    activate: 'las-activate-target',
    confirmActivate: 'las-confirm-activation',
    duplicate: 'las-duplicate-target',
    edit: 'las-edit-target'
  },
  sd: {
    name: 'SM',
    type: 'social_digital',
    create: 'create-sm',
    edit: 'sm-edit-target',
    duplicate: 'sm-duplicate-target',
    activate: 'sm-activate-target',
    confirmActivation: 'sm-confirm-activation',
    workbench: 'sm-workbench'
  },
  ad: {
    name: 'AD',
    type: 'audience_discovery',
    duplicate: 'ad-duplicate-target',
    edit: 'ad-edit-target',
    create: 'create-ad',
    workbench: 'ad-workbench'
  }
}

const getListOfTargets = function () {
  let listOfTargets = []
  for (let k of Object.keys(TARGET_CONSTANTS)) {
    listOfTargets.push(TARGET_CONSTANTS[k])
  }
  return listOfTargets
}

export const listOfTargets = getListOfTargets()

export const getTargetByType = function (type) {
  for (let t of listOfTargets) {
    if (t.type === type) {
      return t
    }
  }
  return null
}



// WEBPACK FOOTER //
// ./src/app/helpers/targets.js